export default __webpack_public_path__ + "static/media/2. mailbox.c781c002.png";